import React, { useEffect, useReducer, useRef } from 'react';
import { adaptGameToContainer, isNotEmpty } from '../../lib/ep';

import { GameContainerWrapper } from './GameContainer';
import NextActionButton from '../games/NextActionButton';
import LeveledHTMLText from './helpers/LeveledHTMLText';
import { useCSS } from '../../lib/hooks';

const SimpleCanvasContainer = (props) => {

	useCSS('comp/games_header.css');

	const stage = props.stage.Stage;
	const promotion = props.promotion;
	const is_test = props?.is_test ?? false;
	const is_builder = props?.is_builder ?? false;

	const gameCanvas = useRef();
	
	const getStartSection = (section) => {
		switch(section) {
			case 'score':
				return 'END_GAME';

			case 'resume':
				return 'RESUME_GAME';
		}

		return 'GAME';
	};

	const initial_state = getStartSection(props.section);

	const [ game, dispatch ] = useReducer((state, action) => {
		switch(action.type) {
			case 'RESUME_GAME':
				return {
					...state,
					state:'RESUME_GAME',
					game_data:action.data,
				};

			case 'END_GAME':
				return {
					...state,
					state:'END_GAME',
					game_data:action.data,
					participate_result:action?.response,
					next_participation:action?.next_participation
				};

			case 'RESTART':
				return {
					...state,
					state:initial_state,
					game_data:{},
				};

			default:
				return state;
		}
	}, {
		state:initial_state,
		participate_result:{},
		game_data:props?.game_data ?? {},
	});

	useEffect(() => {
		dispatch({ type:'RESTART' });
	}, [ stage.reset ]);

	const restartGame = () => {
		props.canPlayAgain(() => {
			dispatch({ type:'RESTART' });
			if(props.onReset != undefined) props.onReset();
		});
	};

	const continueGame = (e) => {
		if(game.participate_result.url != undefined) {
			window.location.href = game.participate_result.url;
			return;
		}
	};

	const onEnded = (type, data) => {
		if(is_test) {
			dispatch({
				type:'END_GAME',
				data,
			});
			return;
		}

		if(is_builder) {
			dispatch({
				type:'RESTART',
			});
		}

		if(props.submitQuiz != undefined) {
			props.submitQuiz(0, data, (response) => {
				let next_participation = false;
				if(response.next_participation != undefined) {
					next_participation = response.next_participation;
					if(next_participation !== false && next_participation !== true) {
						next_participation = EPDateHumanize(EPDateDuration(EPDateDiff(next_participation)));
					}
				}

				dispatch({ type:'END_GAME', data, next_participation, response });
			});
		}
	};

	const onResume = (type, data) => {
		if(is_test) {
			dispatch({
				type:'RESUME_GAME',
				data,
			});
			return;
		}

		dispatch({ type:'RESUME_GAME', data });
	};

	const canvas_props = {
		stage,
		promotion,
		adaptToContainer:adaptGameToContainer,
		onEnded,
		onResume,
		is_builder:props.is_builder,
		is_test:props.is_test,
		is_playable:props.is_playable,
		intl:props.intl,
	};

	const force_game_to_square = props?.force_game_to_square ?? true;

	if(game.state == 'RESUME_GAME') {
		return (
			<section class="is_wrapper gui_pos_rel new_design">
				<section class="gui_game_wrapper">
					<div class="canvas_content" style={{ display:'grid', gap:'1em' }}>
						<div class="game_final_page">
							{React.cloneElement(props.resume_page, {
								...canvas_props,
								user_answer:game.game_data,
								user_data:game.participate_result,
							})}
						</div>
					</div>
				</section>
			</section>
		);
	}

	if(game.state == 'END_GAME') {
		return (
			<section class="is_wrapper gui_pos_rel new_design">
				<section class="gui_game_wrapper">
					<div class="canvas_content" style={{ display:'grid', gap:'1em' }}>
						<div class="game_final_page">
							{React.cloneElement(props.final_page, {
								...canvas_props,
								user_answer:game.game_data,
								user_data:game.participate_result,
							})}
						</div>
						
						{(!is_builder || is_test) && (
							<NextActionButton
								multiparticipation={props.multiparticipation}
								login_type={promotion.login_type}
								status='ok'
								allow_retry={((game?.participate_result?.retries ?? 0) > 1) ? true : false}
								retries={game?.participate_result?.retries ?? 0}
								prize={game?.participate_result?.prize}
								next_participation={game.next_participation}
								continueGame={() => continueGame()}
								restartGame={() => restartGame()}
								is_builder={props.is_builder}
								allow_ranking={false}
								promotion_id={promotion.id}
								override_promo_styles={stage.override_promo_styles}
								intl={props.intl}
							/>
						)}
					</div>
				</section>
			</section>
		);
	}

	return (
		<GameContainerWrapper game_type={props.game_type}>
			<section class="is_wrapper gui_pos_rel new_design">
				{(props?.custom_description ?? false) && (
					<div class="game_introduction_content">
						{React.cloneElement(props.custom_description, {
							gameCanvas,
						})}
					</div>
				)}

				{((props?.custom_description ?? false) === false && isNotEmpty(stage, 'main_description')) && (
					<div class="game_introduction_content">
						<LeveledHTMLText>{stage.main_description}</LeveledHTMLText>
					</div>
				)}

				{(props?.header_image ?? false) && (
					<img src={props.header_image} width="100%" alt="" />
				)}

				<section class="gui_game_wrapper">
					{(force_game_to_square) && (
						<img src={`${window.cdn_url}img/blank_1x1.png`} class="img_pusher" width="100%" alt="" />
					)}

					<div class={`canvas_content${(!force_game_to_square) ? ' gui_pos_rel_important' : ''}`}>
						{React.cloneElement(props.children, {
							...canvas_props,
							ref:gameCanvas,
						})}
					</div>

					{(props?.extra_content ?? false) && (
						<div class="game_extra_contents">
							{React.cloneElement(props.extra_content, {
								gameCanvas,
							})}
						</div>
					)}
				</section>
			</section>
		</GameContainerWrapper>
	)

};

export default SimpleCanvasContainer;